(ns frontend.ui.component.form.view
  (:require
   [frontend.ui.component.form.style :as form-style]
   [frontend.ui.component.select-input.view :as select-input]
   [herb.core :as h]
   [ui.dom-globals :as dg]))


(defn attribute-input
  [attribute label value disabled? on-change!]
  [:<>
   [:div
    {:class (h/<class form-style/form-group)}
    [:label
     {:class (h/<class form-style/label)}
     label]
    [:input
     {:class     (h/<class form-style/input)
      :value     (or value "")
      :disabled  (boolean disabled?)
      :on-change (fn [e]
                   (on-change! attribute (dg/event-target-value e)))}]]])

(defn attribute-select
  [attribute label value options on-change!]
  [:<>
   [:div
    {:class (h/<class form-style/form-group)}
    [:label
     {:class (h/<class form-style/label)}
     label]
    [select-input/select-input
     {:class      (h/<class form-style/input)
      :value      (or value "")
      :on-change  (fn [e]
                    (on-change! attribute e))
      :name-sort? true}
     options]]])
